jQuery(function ($) {
  if ($(window).width() >= 1140) {
    $('.js-staff-card').on('mouseenter mouseleave', function () {
      $(this).toggleClass('staff__team__member__content-wrapper--has-hover');
    });
  } else {
    $('.js-staff-card').on('click', function () {
      $(this).toggleClass('staff__team__member__content-wrapper--has-hover');
    });
  }
  function toggleStaffDropdown() {
    $('.staff__team__filters-dropdown-container').toggleClass('dropdown-active');
    $('.staff__team__filters-dropdown-option-list').slideToggle();
  }
  $('.js-team-filter-dropdown').on('click', function (e) {
    e.preventDefault();
    toggleStaffDropdown();
  });
  (function () {
    const Shuffle = window.Shuffle;
    const gridElement = document.querySelector('.staff__team__grid');
    if (Shuffle) {
      const shuffleInstance = new Shuffle(gridElement, {
        itemSelector: '.staff__team__member',
        speed: 500,
        sizer: '.js-sizer',
        isCentered: true,
      });
      function handleFilterStateChange(clicked, label) {
        $('.staff__team__filters-dropdown-select-text').text(label);
        $('.staff__team__filters-button').removeClass('staff__team__filters-button--active');
        $('.staff__team__filters-button')
          .filter(function (index, element) {
            return $(element).data('location') === clicked;
          })
          .addClass('staff__team__filters-button--active');
      }
      $('.js-team-filter-button').on('click', function (e) {
        e.preventDefault();
        const clicked = $(this).data('location');
        const label = $(this).data('label');
        handleFilterStateChange(clicked, label);
        shuffleInstance.filter(clicked);
      });
      $('.js-team-filters-option').on('click', function (e) {
        const clicked = $(this).data('select');
        const label = $(this).data('label');
        toggleStaffDropdown();
        handleFilterStateChange(clicked, label);
        shuffleInstance.filter(clicked);
      });
    }
  })();
});
